<template>
  <div class="event-grid-container">
    <div class="row">
      <div
        v-for="d in data"
        :key="d.event_id"
        class="columns small-12 medium-6 large-3 grid-item">
        <div class="event-info">
          <a class="event-type">
            {{decode(d.type_title)}}
          </a>
          <a
            :href="d.url"
            class="event-text-link">
            <h3 class="event-title">{{ d.title }}</h3>
            <p class="event-subtitle" v-if="!d.leader_line_1 && !!d.leader_name">with {{ d.leader_name }}</p>
            <p class="event-subtitle" v-if="!!d.leader_line_1">{{ d.leader_line_1 }}</p>
            <p class="event-subtitle-2" v-if="!!d.leader_line_2 && !!d.leader_line_1">{{ d.leader_line_2 }}</p>
            <p class="event-date">{{ d.date_range }}</p>
          </a>
        </div>
        <!--<div class="event-more">
          <a
            :href="d.url"
            class="button">More</a>
        </div>-->
      </div>
    </div>
  </div>
</template>

<script>
import { getConfig, decodeHTML } from "../../utils/index.js";
let sComponents = {};

export default {
  name: "Grid",
  components: sComponents,
  props: {
    data: {
      type: Array,
      required: true
    }
  },
  data: function() {
    return {
      // counter: 0
    };
  },
  watch: {},
  mounted: function() {},
  updated: function() {},
  methods: {
    decode: function(html){
      return decodeHTML(html)
    }
    // detailPage: function(event_id) {
    //   return getConfig("detail") + event_id;
    // }
  }
};
</script>
<style lang="scss" scoped>
.event-grid-container{
    text-align: center;
    .row{
      padding-top: 0;
      justify-content: center;
    }
    .grid-item:last-child{
      margin-right: 0;
    }
    a.event-text-link:active, a.event-text-link:visited{
      color: #63594e;
    }
    a.event-text-link:hover, a.event-text-link:focus{
      color: #3c372e;
    }
    .grid-item{
      position: relative;
      border-right: 1px solid #e5e1dd;
    }
    .grid-item:last-child{
      border-right: 0px;
    }
    .event-info{

    }
    .event-more{

      bottom: 0;
      position: absolute;
      width: 100%;
      a.button{
        font-size: 1.1rem;
        border: 1px solid #b77e46;
        background: #fff;
        color: #b77e46;
        font-weight: 300;
        text-transform: uppercase;
        padding: 0.5rem;
        width: 100%;
        bottom: 0;
        position: absolute;
      }

      a.button:active, a.button:visited{
        background: #fff;
        color: #b77e46;
      }
      a.button:hover, .a.button:focus{
        background-color: #926538;
        color: #fff;
      }

      // If Larger than Mobile
      @media screen and (min-width: 40em){
        margin-top: 1rem;
        width: calc(100% - 3.25rem);
      }
    }

     // If Larger than Mobile
    @media screen and (min-width: 40em){
    }

    p {
      margin:0 !important;
    }

    .event-type{
      font-family: "proxima-nova",sans-serif;
      font-size: 0.70rem;
      color: #a89c8f;
      text-transform: uppercase;
      font-weight: bold;
      letter-spacing: 2px;
    }
    .event-title{
      font-size: 1.25rem;
      font-weight: bold;
      margin-bottom: 0.25rem;
    }
    .event-subtitle, .event-subtitle-2{
      font-size: .9rem;
      font-family: "proxima-nova",sans-serif
    }
    .event-date{
      font-size: .9rem;
      margin-bottom: 0.25rem;
      font-family: "proxima-nova",sans-serif
    }
  }
</style>
